import type { ShortVideo } from '~/composables/shorts';

import { ShortsJsonLdPresenter } from '~/presenters/ShortsJsonLdPresenter';

interface UseShortsHomeFeedJsonLdOptions {
	pageTitle: () => string;
	pageDescription: () => string;
	pageUrl: () => string;
}

export function useShortsHomeFeedJsonLd(
	videosGetter: () => readonly ShortVideo[],
	options: UseShortsHomeFeedJsonLdOptions
) {
	const videos = computed(videosGetter);
	const pageTitle = computed(options.pageTitle);
	const pageDescription = computed(options.pageDescription);
	const pageUrl = computed(options.pageUrl);

	const shortsHomeFeedJsonLd = computed(() =>
		ShortsJsonLdPresenter.getShortsHomeFeedJsonLd({
			videos: videos.value,
			pageUrl: pageUrl.value,
			name: pageTitle.value,
			description: pageDescription.value
		})
	);

	useJsonld(() => shortsHomeFeedJsonLd.value);
}
